import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';
import { SftpImportConfigurationWorkflow, ImportType } from '../../../store/Models/Api/SftpImportModels';

interface ProductIdentificationInfoSectionLocalProps {
    configData: SftpImportConfigurationWorkflow;
}

type ProductIdentificationInfoSectionProps = ProductIdentificationInfoSectionLocalProps & ToxnotComponentProperties;

class ProductIdentificationInfoSectionComponent extends ToxnotComponent<ProductIdentificationInfoSectionProps> {
    public render() {
        const { configData } = this.props;

        return (
            <>
                <p><strong>{this.localizeString("Product/Material Name")}:</strong> {configData.name || 'Not specified'}</p>
                {configData.description && <p><strong>{this.localizeString("Description")}:</strong> {configData.description}</p>}
                {configData.plant && <p><strong>{this.localizeString("Plant Name")}:</strong> {configData.plant}</p>}
                {configData.supplierName && <p><strong>{this.localizeString("Supplier Name")}:</strong> {configData.supplierName}</p>}
                {configData.productNumber && <p><strong>{this.localizeString("Product Number")}:</strong> {configData.productNumber}</p>}
                {configData.supplierPartNumber && <p><strong>{this.localizeString("Supplier Part Number")}:</strong> {configData.supplierPartNumber}</p>}
                {configData.externalDbId && <p><strong>{this.localizeString("External ID")}:</strong> {configData.externalDbId}</p>}
            </>
        );
    }
}

export const ProductIdentificationInfoSection = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(ProductIdentificationInfoSectionComponent);
